import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { WEBApi } from '../API/WEBApi';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Pagination } from 'react-bootstrap';

interface Blog {
    _id: string;
    title: string;
    author: string;
    slug: string;
    date: string;
    content: string;
}

const Blogs: React.FC = () => {
    const [blogs, setBlogs] = useState<Blog[]>([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);


    const navigate = useNavigate();

    const fetchBlogs = async (currentPage: number) => {
        try {
            setLoading(true); // Start loading
            const res = await WEBApi.getBlogs(currentPage);
            setBlogs(res.blogs);
            setTotalPages(res.totalPages);
        } catch (error) {
            console.error('Error fetching blogs:', error);
        } finally {
            setLoading(false); // Stop loading
        }
    };


    useEffect(() => {
        fetchBlogs(page);
    }, [page]);

    const handleDelete = async (id: string) => {
        if (!window.confirm('Are you sure you want to delete this blog?')) return;
        try {
            await WEBApi.deleteBlog(id);
            fetchBlogs(page);
        } catch (error) {
            console.error('Error deleting blog:', error);
            alert('Failed to delete blog. Please try again.');
        }
    };

    const handleEdit = (id: string) => {
        navigate(`/breathe-ev-admin/blogs/edit/${id}`);
    };

    const renderPagination = () => {
        let items = [];
        for (let number = 1; number <= totalPages; number++) {
            items.push(
                <Pagination.Item
                    key={number}
                    active={number === page}
                    onClick={() => setPage(number)}
                >
                    {number}
                </Pagination.Item>
            );
        }
        return (
            <Pagination className="justify-content-end mt-4">
                <Pagination.Prev
                    onClick={() => setPage(page - 1)}
                    disabled={page === 1}
                />
                {items}
                <Pagination.Next
                    onClick={() => setPage(page + 1)}
                    disabled={page === totalPages}
                />
            </Pagination>
        );
    };

    return (
        <main className="container mt-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h3>Blogs</h3>
                <Link to="/breathe-ev-admin/blogs/create" className="btn btn-success">
                    Add Blog
                </Link>
            </div>

            {loading ? (
                <div className="text-center my-4">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Author</th>
                                <th>Date</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {blogs.map(blog => (
                                <tr key={blog._id}>
                                    <td>{blog.title}</td>
                                    <td>{blog.author}</td>
                                    <td>{new Date(blog.date).toLocaleDateString()}</td>
                                    <td>
                                        <button
                                            className="btn btn-sm btn-warning me-2"
                                            onClick={() => handleEdit(blog._id)}
                                        >
                                            Edit
                                        </button>
                                        <button
                                            className="btn btn-sm btn-danger"
                                            onClick={() => handleDelete(blog._id)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {renderPagination()}
                </>
            )}


        </main>
    );
};

export default Blogs;
